import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    pageStack:[],
    preveiwOpen:false,
    aboutUsOpen:false,
  },
  mutations: {
    pushPageStack (state,url) {
      state.pageStack.push(url);
    },
    unshiftPageStack (state) {
      state.pageStack.pop();
    },
    OpenClose(state){
      state.preveiwOpen=!state.preveiwOpen;
    },
    OpenCloseAboutUs(state){
      state.aboutUsOpen=!state.aboutUsOpen;
    },
  }
})



// WEBPACK FOOTER //
// ./src/store/pageStackStore.js